import React from 'react';
import { Card, Typography, List, Space, Alert } from 'antd';
import { Link } from 'react-router-dom';

const { Title, Paragraph, Text } = Typography;

const LegalNotices = () => {
  const legalItems = [
    {
      title: 'Propriété du site web',
      content: 'Nomidya est la propriété de Nomidya SARL, une société enregistrée.'
    },
    {
      title: 'Contact',
      content: 'Pour toute question ou demande concernant notre site web ou nos services, vous pouvez nous contacter à l\'adresse e-mail suivante : contact@nomidya.com.'
    },
    {
      title: 'Propriété intellectuelle',
      content: 'Tous les contenus, textes, images, logos, vidéos et autres éléments présents sur le site web de Nomidya sont protégés par les lois sur la propriété intellectuelle. Toute reproduction, distribution ou utilisation non autorisée de ces contenus est strictement interdite.'
    },
    {
      title: 'Confidentialité des données',
      content: (
        <span>
          Nous accordons une grande importance à la protection de vos données personnelles. Pour en savoir plus sur notre politique de confidentialité et la manière dont nous collectons, utilisons et protégeons vos données, veuillez consulter notre{' '}
          <Link to="/privacy-policy" style={{ color: '#1890ff', fontWeight: 'bold' }}>
            politique de confidentialité
          </Link>.
        </span>
      )
    },
    {
      title: 'Utilisation des cookies',
      content: (
        <span>
          Notre site web utilise des cookies pour améliorer votre expérience de navigation. En utilisant notre site web, vous consentez à l'utilisation de cookies conformément à notre{' '}
          <Link to="/cookie-policy" style={{ color: '#1890ff', fontWeight: 'bold' }}>
            politique en matière de cookies
          </Link>.
        </span>
      )
    },
    {
      title: 'Responsabilité',
      content: 'Nous nous efforçons de fournir des informations exactes et à jour sur notre site web. Cependant, nous ne pouvons garantir l\'exactitude, l\'exhaustivité ou la fiabilité des informations fournies. En utilisant notre site web, vous acceptez d\'assumer la responsabilité de toute action entreprise en fonction des informations présentes sur ce site.'
    },
    {
      title: 'Liens externes',
      content: 'Notre site web peut contenir des liens vers des sites externes gérés par des tiers. Nous n\'assumons aucune responsabilité quant au contenu ou aux pratiques de confidentialité de ces sites externes.'
    },
    {
      title: 'Modification des mentions légales',
      content: 'Nous nous réservons le droit de modifier les présentes mentions légales à tout moment. Les modifications prendront effet dès leur publication sur notre site web. Il vous incombe de consulter régulièrement cette page pour prendre connaissance des éventuelles mises à jour.'
    }
  ];

  return (
    <div className="legal-notices-page" style={{ padding: '20px 0' }}>
      <div className="container">
        <Card className="mb-4" style={{ boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}>
          {/* En-tête */}
          <div style={{ textAlign: 'center', marginBottom: '30px' }}>
            <Title level={1} style={{ color: '#1890ff' }}>
              Mentions Légales
            </Title>
            <Paragraph style={{ fontSize: '16px', color: '#666', maxWidth: '800px', margin: '0 auto' }}>
              Bienvenue sur la page des mentions légales de Nomidya. Nous accordons une grande importance à la transparence et au respect des lois en vigueur concernant notre plateforme éducative en ligne.
            </Paragraph>
          </div>

          {/* Message d'information */}
          <Alert
            message="Information importante"
            description="Veuillez prendre un moment pour lire les informations suivantes relatives à notre site web."
            type="info"
            showIcon
            style={{ marginBottom: '30px' }}
          />

          {/* Contenu des mentions légales */}
          <List
            itemLayout="vertical"
            size="large"
            dataSource={legalItems}
            renderItem={(item, index) => (
              <List.Item key={index}>
                <Card 
                  hoverable
                  style={{ 
                    borderLeft: `4px solid #1890ff`,
                    marginBottom: '16px'
                  }}
                >
                  <Space direction="vertical" size="small" style={{ width: '100%' }}>
                    <Title level={4} style={{ margin: 0, color: '#1890ff' }}>
                      {item.title}
                    </Title>
                    <Paragraph style={{ 
                      fontSize: '15px', 
                      lineHeight: '1.6', 
                      margin: 0,
                      textAlign: 'justify'
                    }}>
                      {item.content}
                    </Paragraph>
                  </Space>
                </Card>
              </List.Item>
            )}
          />

          {/* Message de conclusion */}
          <Card style={{ 
            marginTop: '30px',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            textAlign: 'center'
          }}>
            <Title level={3} style={{ color: 'white', marginBottom: '16px' }}>
              Acceptation des Conditions
            </Title>
            <Paragraph style={{ 
              fontSize: '16px', 
              lineHeight: '1.7', 
              color: 'white',
              margin: 0
            }}>
              En utilisant notre site web, vous acceptez ces mentions légales dans leur intégralité. Nous vous remercions de votre visite sur Nomidya et nous sommes heureux de vous accompagner dans votre parcours d'apprentissage.
            </Paragraph>
          </Card>

          {/* Information de contact */}
          <Card style={{ 
            marginTop: '20px', 
            background: '#f0f2f5',
            textAlign: 'center'
          }}>
            <Text style={{ fontSize: '14px', color: '#666' }}>
              Pour toute question concernant ces mentions légales, n'hésitez pas à nous contacter à{' '}
              <Text strong style={{ color: '#1890ff' }}>contact@nomidya.com</Text>
            </Text>
          </Card>
        </Card>
      </div>
    </div>
  );
};

export default LegalNotices;